/**
 * محاسبات جمع‌بندی جدول (صفحه فعلی + کل نتایج فیلترشده).
 * type: sum | wavg | unique | none
 */
// این فایل خودش `faNum` را export می‌کند (با امضای متفاوت)، پس قالب‌بندِ
// مشترک با نامِ دیگری وارد می‌شود.
import { faNum as faFormat } from "./faNumberFormat";

function cellValue(record, dataIndex) {
  if (dataIndex == null || record == null) return undefined;
  if (Array.isArray(dataIndex)) return dataIndex.reduce((o, k) => (o == null ? o : o[k]), record);
  return record[dataIndex];
}

function toNum(v) {
  if (v == null || v === "") return null;
  if (typeof v === "number") return Number.isFinite(v) ? v : null;
  const s = String(v)
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
    .replace(/[,،٬‌\s]/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

/** جمع ساده */
export function sumField(rows, dataIndex) {
  let s = 0;
  let any = false;
  for (const r of rows || []) {
    const n = toNum(cellValue(r, dataIndex));
    if (n == null) continue;
    s += n;
    any = true;
  }
  return any ? s : null;
}

/**
 * میانگین وزنی؛ اگر وزن مبنا نبود → میانگین ساده.
 * valueKey = فیلد فی، weightKey = فیلد وزن (مثلاً balance_kg / weight_kg)
 */
export function weightedAvg(rows, valueKey, weightKey) {
  let wSum = 0;
  let vwSum = 0;
  let plainSum = 0;
  let plainN = 0;
  let usedWeight = false;
  for (const r of rows || []) {
    const v = toNum(cellValue(r, valueKey));
    if (v == null) continue;
    const w = weightKey != null ? toNum(cellValue(r, weightKey)) : null;
    if (w != null && w > 0) {
      vwSum += v * w;
      wSum += w;
      usedWeight = true;
    } else {
      plainSum += v;
      plainN += 1;
    }
  }
  if (usedWeight && wSum > 0) return vwSum / wSum;
  if (plainN > 0) return plainSum / plainN;
  return null;
}

/** تعداد مقادیر یکتا + نقشهٔ تعداد هر گزینه */
export function uniqueCount(rows, dataIndex) {
  const counts = new Map();
  for (const r of rows || []) {
    const raw = cellValue(r, dataIndex);
    if (raw == null || raw === "") continue;
    const key = String(raw);
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  return { count: counts.size, counts };
}

/** فقط تعداد مقادیر یکتا — بدون فهرست جزئیات گزینه‌ها */
export function uniqueSummaryText(rows, dataIndex) {
  const { count } = uniqueCount(rows, dataIndex);
  if (!count) return "—";
  return `${faFormat(count)} یکتا`;
}

export function computeFieldSummary(rows, spec) {
  if (!spec || spec.type === "none") return null;
  const { dataIndex, type, weightKey } = spec;
  if (type === "sum") return sumField(rows, dataIndex);
  if (type === "wavg") return weightedAvg(rows, dataIndex, weightKey);
  if (type === "unique") return uniqueCount(rows, dataIndex);
  return null;
}

/** برش صفحهٔ فعلی از دادهٔ فیلترشده (pagination کلاینتی antd) */
export function pageSlice(rows, pagination) {
  const list = rows || [];
  if (!pagination || pagination === false) return list;
  const pageSize = pagination.pageSize || 10;
  const current = pagination.current || 1;
  const start = (current - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function faNum(n, digits) {
  if (n == null || !Number.isFinite(Number(n))) return "—";
  return faFormat(Number(n), digits != null
    ? { maximumFractionDigits: digits, minimumFractionDigits: 0 }
    : undefined);
}
